// src/components/layout/PublicLayout.tsx
import { Outlet, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Activity, LogIn } from 'lucide-react';
import { appConfig } from '../../config/app.config';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Minimal branded header */}
      <header className="bg-brand-700 text-white px-5 py-3 flex items-center gap-3 shadow-sm">
        <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center">
          <Activity className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="text-sm font-semibold tracking-wide">{appConfig.appName}</div>
          <div className="text-[10px] text-brand-200">Online Appointment Booking</div>
        </div>
        <div className="ml-auto flex items-center gap-3">
          <Link
            to="/patient-login"
            className="flex items-center gap-1.5 text-xs font-medium text-white/80 hover:text-white bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition-all duration-150"
          >
            <LogIn className="w-3.5 h-3.5" />
            Patient Portal
          </Link>
        </div>
      </header>

      <main className="flex-1 animate-fade-up">
        <Outlet />
      </main>

      <footer className="py-4 text-center text-xs text-slate-400 border-t border-slate-200">
        &copy; {new Date().getFullYear()} {appConfig.appName}
      </footer>

      <Toaster
        position="bottom-right"
        gutter={8}
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: 'Outfit, sans-serif',
            fontSize: '13px',
            borderRadius: '10px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          },
          success: {
            iconTheme: { primary: '#10b981', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />
    </div>
  );
}
